import React from 'react';
import LiveClockAndDateApp from '../Functionality/LiveClockAndDateApp';
import { DATE_TIME_FORMAT_NAME_MODEL, getDateFormat } from '../../../Apis/functions';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

const LiveClockAndDate = () => {
    const { hourFormat } = LiveClockAndDateApp();

    return (
        <div className='d-flex align-items-center gap-3 w-100'>
            <p className='font-color-primary-800 ibl-font-w-600 fs-72px mb-0'>{hourFormat}</p>

            <div className='mt-1 vertical-separator-shades-950 h-100px' />

            <div className='d-flex flex-column justify-content-center'>
                <p className='mb-0 fs-24px ibl-font-w-400 font-color-primary-950'>
                    {getDateFormat(new Date(), false, DATE_TIME_FORMAT_NAME_MODEL.shortMonthDay)}
                </p>

                <p className='mb-0 fs-24px ibl-font-w-400 font-color-primary-950'>
                    {getDateFormat(new Date(), null, DATE_TIME_FORMAT_NAME_MODEL.weekDay)}
                </p>
            </div>
        </div>
    );
};

export default LiveClockAndDate;
